import validate from "/app/node_modules/.pnpm/nuxt@3.15.4_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22.10.7_db0@0.3.2_es_43aae2a113bed0230e3f586d982cb340/node_modules/nuxt/dist/pages/runtime/validate.js";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {
  "check-authenticated": () => import("/app/layers/base/middleware/check-authenticated.ts"),
  "common-loader": () => import("/app/apps/onboarding/middleware/common-loader.ts"),
  "lti-onboarding": () => import("/app/apps/onboarding/middleware/lti-onboarding.ts"),
  "page-redirection": () => import("/app/apps/onboarding/middleware/page-redirection.ts"),
  "parent-login": () => import("/app/apps/onboarding/middleware/parent-login.ts"),
  "redirect-home": () => import("/app/apps/onboarding/middleware/redirect-home.ts")
}